<!-- @format -->

<sis-contextual-notification variant="light" *ngIf="courseUnitGroupEnrolmentRights?.length > 0" data-cy="different-version-purchase">
  <p>{{ "OPEN_UNIVERSITY.STUDY_OFFERING.DIFFERENT_VERSION_PURCHASES" | translate }}</p>
  <ul>
    <li *ngFor="let versionName of versionNames$ | async">
      {{ versionName }}
    </li>
  </ul>
</sis-contextual-notification>
